<a *ngIf="!unauthorized" [routerLink]="['/cb/login']" routerLinkActive="router-link-active">go to login</a>

<div *ngIf="unauthorized">Unauthorized</div>
